/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_P2Inputs */

const en_home_artcraft_p2 = /** @type {(inputs: Home_Artcraft_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ArtCraft Launcher installs CADCraft next to the other ArtCraft apps and keeps each one up to date. If you prefer, you can download a single CADCraft installer, a portable build or the self-hostable web version instead.`)
};

/**
* | output |
* | --- |
* | "The ArtCraft Launcher installs CADCraft next to the other ArtCraft apps and keeps each one up to date. If you prefer, you can download a single CADCraft inst..." |
*
* @param {Home_Artcraft_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_p2 = /** @type {((inputs?: Home_Artcraft_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_p2(inputs)
});
export { home_artcraft_p2 as "home.artcraft.p2" }